import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { getCurrentInstance } from 'vue';
import { useVentureId } from '~/functions/accounts';
import { useCompanyTypstExportAvailability, useCompanyTypstPdfDownload } from '~/functions/companyTypstExport';
import { Module, useGetAccountQuery } from '~/types/types';
export default defineComponent({
  props: {
    ventureName: {
      type: String,
      default: undefined
    },
    website: {
      type: String,
      default: undefined
    }
  },
  setup: function setup() {
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery({
        id: ventureId === null || ventureId === void 0 ? void 0 : ventureId.value
      }),
      result = _useGetAccountQuery.result;
    var hasEsgModule = computed(function () {
      var _result$value, _result$value$getAcco, _result$value$getAcco2;
      return !!((_result$value = result.value) !== null && _result$value !== void 0 && (_result$value$getAcco = _result$value.getAccount) !== null && _result$value$getAcco !== void 0 && (_result$value$getAcco2 = _result$value$getAcco.bookedModules) !== null && _result$value$getAcco2 !== void 0 && _result$value$getAcco2.includes(Module.Esg));
    });
    var hasImpactGoalModule = computed(function () {
      var _result$value2, _result$value2$getAcc, _result$value2$getAcc2;
      return !!((_result$value2 = result.value) !== null && _result$value2 !== void 0 && (_result$value2$getAcc = _result$value2.getAccount) !== null && _result$value2$getAcc !== void 0 && (_result$value2$getAcc2 = _result$value2$getAcc.bookedModules) !== null && _result$value2$getAcc2 !== void 0 && _result$value2$getAcc2.includes(Module.ImpactGoal));
    });
    var hasMetricsModule = computed(function () {
      var _result$value3, _result$value3$getAcc, _result$value3$getAcc2;
      return !!((_result$value3 = result.value) !== null && _result$value3 !== void 0 && (_result$value3$getAcc = _result$value3.getAccount) !== null && _result$value3$getAcc !== void 0 && (_result$value3$getAcc2 = _result$value3$getAcc.bookedModules) !== null && _result$value3$getAcc2 !== void 0 && _result$value3$getAcc2.includes(Module.Metrics));
    });
    var hasKfWMetricAssignments = computed(function () {
      var _result$value4, _result$value4$getAcc;
      return !!((_result$value4 = result.value) !== null && _result$value4 !== void 0 && (_result$value4$getAcc = _result$value4.getAccount) !== null && _result$value4$getAcc !== void 0 && _result$value4$getAcc.hasKfw) || false;
    });
    var _useGetAccountQuery2 = useGetAccountQuery(),
      loggedInAccountResult = _useGetAccountQuery2.result,
      loggedInAccountLoading = _useGetAccountQuery2.loading;
    var loggedInAccountType = computed(function () {
      var _loggedInAccountResul, _loggedInAccountResul2;
      return (_loggedInAccountResul = loggedInAccountResult.value) === null || _loggedInAccountResul === void 0 ? void 0 : (_loggedInAccountResul2 = _loggedInAccountResul.getAccount) === null || _loggedInAccountResul2 === void 0 ? void 0 : _loggedInAccountResul2.type;
    });
    var _useCompanyTypstExpor = useCompanyTypstExportAvailability(ventureId),
      typstAvailabilityLoading = _useCompanyTypstExpor.loading,
      typstAvailableOptions = _useCompanyTypstExpor.availableOptions;
    var _useCompanyTypstPdfDo = useCompanyTypstPdfDownload(ventureId),
      typstExporting = _useCompanyTypstPdfDo.exporting,
      downloadTypstOption = _useCompanyTypstPdfDo.downloadTypstOption;
    var typstSectionLabel = function typstSectionLabel(key) {
      var map = {
        strategy: 'labelStrategy',
        carry: 'labelCarry',
        ghg: 'labelGhg',
        esg: 'labelEsg'
      };
      return proxy.$t(map[key] || 'exportAsPdf');
    };
    var typstDirectOption = computed(function () {
      if (typstAvailabilityLoading.value) return null;
      var options = typstAvailableOptions.value;
      return options.length === 1 ? options[0] : null;
    });
    var typstMenuLabel = computed(function () {
      var option = typstDirectOption.value;
      if (!option) return proxy.$t('exportAsPdf');
      return proxy.$t('exportNamedPdf', {
        name: typstSectionLabel(option.key)
      });
    });
    var downloadSingleTypst = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var option;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              option = typstDirectOption.value;
              if (!(!option || typstExporting.value)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _context.next = 6;
              return downloadTypstOption(option);
            case 6:
              _context.next = 12;
              break;
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              console.error('Company Typst direct export failed', _context.t0);
              window.$nuxt.$emit('userError', {
                message: proxy.$t('errorTypstFailed')
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 8]]);
      }));
      return function downloadSingleTypst() {
        return _ref2.apply(this, arguments);
      };
    }();
    return {
      ventureId: ventureId,
      hasEsgModule: hasEsgModule,
      hasImpactGoalModule: hasImpactGoalModule,
      hasMetricsModule: hasMetricsModule,
      hasKfWMetricAssignments: hasKfWMetricAssignments,
      loggedInAccountType: loggedInAccountType,
      loggedInAccountLoading: loggedInAccountLoading,
      typstDirectOption: typstDirectOption,
      typstMenuLabel: typstMenuLabel,
      typstExporting: typstExporting,
      downloadSingleTypst: downloadSingleTypst
    };
  }
});